import $  from 'jquery';
import { videoBlock } from '../template-parts/blocks/video'

function blogLoadMore() {
    var page = 2; // Page number to start from
    var loading = false; // Track if an AJAX request is in progress
    var mainContainer = $('.blog-archive__main'); // Cache the button element
    var $loadMoreButton = $('#load-more-button'); // Cache the button element
    var $loadMoreContainer = $('.load-more-container');

    // Load more button click event
    $loadMoreButton.click(function(){
        if (loading) return; // Prevent multiple clicks while an AJAX request is in progress

        var $this = $(this);
        $this.addClass('loading');
        loading = true;

        var data = {
            'action': 'load_more_posts',
            'page': page,
        };

        $.ajax({
            url: ajaxObject.ajax_url,
            data: data,
            type: 'POST',
            success:function(data){
                if( data ) {
                    $this.removeClass('loading');
                    $('.blog-archive__main ul').append(data);
                    videoBlock();
                    page++;
                } else {
                    $this.remove(); // No more posts to load, so remove the button
                }
                loading = false; // Reset the loading flag

                // Check if there are no more posts and hide the button
                if (page > mainContainer.data('max-page')) {
                    $loadMoreContainer.remove();
                }
            }
        });
    });
}

export { blogLoadMore }